import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-xl-4 col-lg-4 col-xxxl-4 col-sm-6" }
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white expected-earnings-box" }
const _hoisted_4 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_5 = {
  id: "expectedEraningsChart",
  class: "chart"
}
const _hoisted_6 = { class: "col-xl-4 col-lg-4 col-xxxl-4 col-sm-6" }
const _hoisted_7 = { class: "card mb-25 border-0 rounded-0 bg-white expected-earnings-box" }
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_9 = {
  id: "expectedEraningsChart",
  class: "chart"
}
const _hoisted_10 = { class: "col-xl-4 col-lg-4 col-xxxl-4 col-sm-6" }
const _hoisted_11 = { class: "card mb-25 border-0 rounded-0 bg-white expected-earnings-box" }
const _hoisted_12 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_13 = {
  id: "expectedEraningsChart",
  class: "chart"
}
const _hoisted_14 = { class: "card mb-25 border-0 rounded-0 bg-white sales-pos-location-box" }
const _hoisted_15 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_16 = {
  id: "weeklySalesChart",
  class: "chart"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _cache[0] || (_cache[0] = _createStaticVNode("<span class=\"d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis\"> Coût moyen de passage portuaire des navires </span><h4 class=\"fw-black mb-12 lh-1\">120 000</h4><ul class=\"list ps-0 mb-0 list-unstyled mt-15\"><li class=\"text-muted position-relative fw-medium\"> Maxinum: <span class=\"text-black fw-bold\">150 000</span></li><li class=\"text-muted position-relative fw-medium\"> moyenne: <span class=\"text-black fw-bold\">120 000</span></li><li class=\"text-muted position-relative fw-medium\"> Mininum: <span class=\"text-black fw-bold\">80 000</span></li></ul>", 3)),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_apexchart, {
                type: "donut",
                height: "180",
                options: _ctx.expectedEraningsChart,
                series: _ctx.expected
              }, null, 8, ["options", "series"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _cache[1] || (_cache[1] = _createStaticVNode("<span class=\"d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis\"> Coût de revient des marchandises essentielles </span><h4 class=\"fw-black mb-12 lh-1\">220 000</h4><ul class=\"list ps-0 mb-0 list-unstyled mt-15\"><li class=\"text-muted position-relative fw-medium\"> Maxinum - <span class=\"text-black fw-bold\">265 000</span></li><li class=\"text-muted position-relative fw-medium\"> moyenne - <span class=\"text-black fw-bold\">220 000</span></li><li class=\"text-muted position-relative fw-medium\"> Mininum - <span class=\"text-black fw-bold\">100 000</span></li></ul>", 3)),
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_apexchart, {
                type: "donut",
                height: "180",
                options: _ctx.expectedEraningsChart2,
                series: _ctx.expected
              }, null, 8, ["options", "series"])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _cache[2] || (_cache[2] = _createStaticVNode("<span class=\"d-block mb-6 fs-13 text-uppercase fw-medium text-dark-emphasis\"> Coût moyen de passage portuaire </span><h4 class=\"fw-black mb-12 lh-1\">150 000</h4><ul class=\"list ps-0 mb-0 list-unstyled mt-15\"><li class=\"text-muted position-relative fw-medium\"> Maxinum - <span class=\"text-black fw-bold\">165 000</span></li><li class=\"text-muted position-relative fw-medium\"> moyenne - <span class=\"text-black fw-bold\">150 000</span></li><li class=\"text-muted position-relative fw-medium\"> Mininum - <span class=\"text-black fw-bold\">100 000</span></li></ul>", 3)),
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_apexchart, {
                type: "donut",
                height: "180",
                options: _ctx.expectedEraningsChart1,
                series: _ctx.expected
              }, null, 8, ["options", "series"])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"mb-15 mb-sm-0 d-sm-flex align-items-center justify-content-between\"><div class=\"title\"><span class=\"fw-medium text-muted fs-13 d-block mb-5 text-uppercase\"> Navire opérant sans licence et suspectés de non-conformité </span></div><div class=\"card-select mt-10 mt-sm-0 d-inline-block d-sm-flex align-items-center ps-10 pe-10 pt-5 pb-5\"><span class=\"fw-medium text-muted me-8\">Sélectionner</span><select class=\"form-select shadow-none text-black border-0 ps-0 pt-0 pb-0 pe-20 fs-14 fw-medium\"><option value=\"1\" class=\"fw-medium\">Par semaine</option><option value=\"2\" class=\"fw-medium\">Ce mois-ci</option><option value=\"3\" class=\"fw-medium\" selected>Cette année</option></select></div></div>", 1)),
        _createElementVNode("div", _hoisted_16, [
          _createVNode(_component_apexchart, {
            type: "line",
            height: "375",
            options: _ctx.weeklySalesChart,
            series: _ctx.sales
          }, null, 8, ["options", "series"])
        ])
      ])
    ])
  ], 64))
}